import type { CSSProperties } from 'react';

/**
 * Inline icon on the 24 × 24 view box (02 §1.11): stroked with round caps and, unless `joins` is
 * false (the plus signs), round joins; or filled.
 */
export function Icon({ d, size, stroke, width = 1.6, joins = true, fill, style }: {
  readonly d: string | readonly string[]; readonly size: number; readonly stroke?: string; readonly width?: number;
  readonly joins?: boolean; readonly fill?: string; readonly style?: CSSProperties;
}) {
  const paths = typeof d === 'string' ? [d] : d;
  const look: CSSProperties = fill
    ? { ...style }
    : { fill: 'none', stroke, strokeWidth: width, strokeLinecap: 'round', ...(joins ? { strokeLinejoin: 'round' } : {}), ...style };
  return <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={look}>
    {paths.map((path) => <path key={path} d={path} style={fill ? { fill } : undefined} />)}
  </svg>;
}
